<ng-template #crudActionsTemplateRef>
    <div class="crud-buttons w-100">
        <button type="button" class="btn btn-sm btn-teal" (click)="downloadAuditReport(auditFilterForm);">
            <span class="mdi mdi-download"></span>
            <span class="ms-2">Audit Report</span>
        </button>
    </div>
</ng-template>

<div class="row">
    <div class="col-12 mt-4">
        <div class="card border-0 shadow-sm">
            <div class="row mb-2">
                <div class="col-auto rounded bg-orange text-center card-icon rounded-pill d-flex align-items-center justify-content-center text-white">
                    <i class="mdi mdi-history h4 mb-0"></i>
                    <span class="h5 mb-0 fw-normal d-none d-sm-inline ms-2">Audit Log</span>
                </div>
            </div>
            <div class="card-header border-0 bg-white sticky-top mt-2">
                <form #auditFilterForm="ngForm">
                    <div class="row">
                        <ng-container *ngIf="flow === 'admin'">
                            <div class="col-12 col-md-4 col-lg-3 col-xl-2 form-label-group">
                                <custom-select class="form-group form-label-group" [field]="(applicationSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="appName = $event?.[0]; organisations = []; getOrganisations(appName);"></custom-select>
                            </div>
                            <div class="col-12 col-md-4 col-lg-3 col-xl-2 form-label-group">
                                <custom-select class="form-group form-label-group" [field]="(applicationDomainSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="domainId = $event?.[0]; toast?.clear();"></custom-select>
                            </div>
                        </ng-container>
                        <div class="col-12 col-md-4 col-lg-3 col-xl-2 form-label-group">
                            <input type="datetime-local" name="startDate" id="start-date" class="form-control" [max]="today | date: 'yyyy-MM-ddTHH:ss'" (change)="checkLimit(startDateSpy, endDateSpy);" ngModel required #startDateSpy="ngModel" />
                            <label for="start-date" class="required">Start Date</label>
                        </div>
                        <div class="col-12 col-md-4 col-lg-3 col-xl-2 form-label-group">
                            <input type="datetime-local" name="endDate" id="end-date" class="form-control" [min]="startDateSpy?.value" [max]="today | date: 'yyyy-MM-ddTHH:ss'" (change)="checkLimit(startDateSpy, endDateSpy);" ngModel required #endDateSpy="ngModel" />
                            <label for="end-date" class="required">End Date</label>
                        </div>
                        <div class="col-12 col-md-4 col-lg-auto form-label-group">
                            <custom-select class="form-group form-label-group" [field]="(actionSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="selectedAction = $event?.[0];"></custom-select>
                        </div>
                        <div class="col-auto form-label-group">
                            <button type="button" appButton class="btn btn-sm btn-primary" [disabled]="flow === 'admin' ? (!appName || !domainId || auditFilterForm?.invalid) : auditFilterForm?.invalid" (click)="searchAuditLog(auditFilterForm)" #auditFilterSubmitBtn>Submit</button>
                            <button type="button" appButton class="btn btn-sm btn-outline-secondary ms-2" (click)="resetForm(auditFilterForm);">Reset</button>
                        </div>
                    </div>
                </form>
                <div class="row justify-content-end align-items-center">
                    <div class="col-auto ps-0 ps-sm-2">
                        <div class="form-label-group mt-0 ps-2">
                          <input type="text" placeholder="Search text" class="form-control form-control-sm" id="text-search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (keyup)="onSearch(textSearchSpy?.value)" #textSearchSpy />
                          <label class="pb-3" for="text-search">Search</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <com-pagination [results]="auditList" [filterColumns]="filterColumns" (dataEmitter)="paginationHandler($event);" *ngIf="!textSearchSpy?.value"></com-pagination>
                    </div>
                </div>
            </div>
            <div class="card-body overflow-md-auto">
                <div class="row">
                    <div class="col-12">
                        <table class="table table-hover">
                            <thead>
                                <tr class="bg-white position-sticky shadow-sm audit-table-header" [ngClass]="flow === 'admin' ? 'admin-flow' : 'domain-flow'">
                                    <th>Application</th>
                                    <th>Operation Time</th>
                                    <th>Info</th>
                                    <th>Action</th>
                                    <th class="maxw-350">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="auditList?.length">
                                  <tr *ngFor="let auditObj of textSearchSpy?.value ? searchResults : auditList?.slice((paginationParams?.pageNo-1)*paginationParams?.pageSize, paginationParams?.pageNo*paginationParams?.pageSize)">
                                      <td>
                                        <span>{{auditObj?.appName || '-'}}</span>
                                        <span class="badge border border-secondary text-black fw-normal ms-1 rounded-pill pointer" title="Organisation" data-bs-placement="right">{{auditObj?.domainName || '-'}}</span>
                                      </td>
                                      <td class="text-nowrap">{{(auditObj?.operationTime | date:'dd MMM y hh:mm a') || '-'}}</td>
                                      <td>
                                          <p class="mb-0 text-break">
                                              <span class="small text-muted">Actor:</span> {{auditObj?.actor || '-'}}
                                            </p>
                                            <p class="mb-0 text-break" *ngIf="auditObj?.subject">
                                                <span class="small text-muted">Subject:</span> {{auditObj?.subject}}
                                            </p>
                                        </td>
                                        <td>{{auditObj?.action || '-'}}</td>
                                        <td class="text-break maxw-350">{{auditObj?.description || '-'}}</td>
                                  </tr>
                              </ng-container>
                            </tbody>
                          </table>
                          <p class="mb-0" *ngIf="textSearchSpy?.value && !searchResults?.length">No data found</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>